import { BlogArticleSummary } from '../util/types';

const ArticlesGrid = ({ articles }: { articles: BlogArticleSummary[] }) => {
  return (
    <div className='grid grid-cols-3 gap-6'>
      {articles.map((article) => (
        <a
          key={article.fields.title}
          href={import.meta.env['VITE_STATIC_FILES_URL'] + '/blog/' + article.fields.slug}
          className='overflow-clip rounded-md h-full flex flex-col shadow-lg bg-white'
        >
          <img
            src={article.fields.bannerImage?.fields.file?.url ?? ''}
            className='bg-secondary-brand-50 h-[213px]'
          />
          <h3 className='m-4 mt-6 text-2xl leading-7 text-gray-500'>{article.fields.title}</h3>
          <p
            className='m-4 text-gray-500'
            dangerouslySetInnerHTML={{ __html: article.fields.metaDescription }}
          />
          {/* Looks like a link, but isn't one since the entire card is an <a> tag */}
          <span className='m-4 blue-link mt-auto'>Continue reading &gt;</span>
        </a>
      ))}
    </div>
  );
};

export default ArticlesGrid;
